import { selectEntities, select, selectAll } from './applicationSelectors';

export const selectComponentEntities = selectEntities('components');
export const selectComponents = selectAll(selectComponentEntities);
export const selectComponent = select(selectComponentEntities);
